import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { switchMap, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export const authHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const oidcSecurityService = inject(OidcSecurityService);

  const allowedDomains = [environment.apiUrl];

  const isAllowedDomain = allowedDomains.some((domain) =>
    req.url.startsWith(domain)
  );

  if (!isAllowedDomain) {
    return next(req);
  }

  return oidcSecurityService.getIdToken().pipe(
    switchMap((token) => {
      const headers = req.headers
        .append('Authorization', `Bearer ${token as string}`)
        .append('accept', 'application/json')
        .append('Content-Type', 'application/json');
      const newReq = req.clone({
        headers: headers,
      });

      console.log(token);

      return next(newReq).pipe(
        catchError((err) => {
          throw err;
        })
      );
    })
  );
};
